import { Link } from '@tanstack/react-router';
import { ArrowRight, CircleArrowLeft } from 'lucide-react';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~/shared/shadcn/ui/card';
import { Button } from '~shared/shadcn/ui/button';

import { RevenueSnapshot } from './revenue-snapshot';
import { ScheduledAndUpcoming } from './scheduled-and-upcoming';

export const PaymentDashboard = () => {
  return (
    <div className='min-w-0 space-y-10'>
      <Link to='/dashboard' className='flex min-w-0 items-center gap-2'>
        <CircleArrowLeft className='size-6 shrink-0' />
        <h2 className='min-w-0 text-xl font-semibold sm:text-2xl'>
          Payment Dashboard
        </h2>
      </Link>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-4'>
        {/* <DashboardCard
          title='Revenue Snapshot'
          description='Track income trends at a glance'
          href='/payment/revenue-snapshot'
        /> */}
        <DashboardCard
          title='Outstanding & Overdue'
          description='Help studio owners follow up on unpaid bills'
          href='/payment/outstanding-and-overdue'
        />
        <DashboardCard
          title='Failed & Refunded'
          description='Catch lost revenue early'
          href='/payment/failed-and-refunded'
        />
        <DashboardCard
          title='Invoices'
          description='Browse and filter invoices by date, status, and amount'
          href='/payment/invoices'
        />
        <DashboardCard
          title='Payment Run Review'
          description='Review scheduled charges, flagged items, and run totals before processing'
          href='/payment/payment-run-review'
        />
      </div>
      <RevenueSnapshot />
      <ScheduledAndUpcoming />
    </div>
  );
};

function DashboardCard({
  title,
  description,
  href,
}: {
  title: string;
  description: string;
  href: string;
}) {
  return (
    <Card className='flex flex-col transition-shadow hover:shadow-md'>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className='mt-auto'>
        <Button className='w-full' asChild>
          <Link to={href}>
            View Dashboard
            <ArrowRight />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
